import { render, staticRenderFns } from "./vcCrud.vue?vue&type=template&id=df8998a4&scoped=true&"
import script from "./vcCrud.vue?vue&type=script&lang=js&"
export * from "./vcCrud.vue?vue&type=script&lang=js&"
import style0 from "./vcCrud.vue?vue&type=style&index=0&id=df8998a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8998a4",
  null
  
)

export default component.exports